export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? ''
export const GACHA_EVENT_ID = import.meta.env.VITE_GACHA_EVENT_ID ?? '1'
export const IS_MOCK = import.meta.env.VITE_USE_MOCK === 'true'
export const APP_REDIRECT_URL = 'https://www.sugeo.onl/'
export const MIXPANEL_TOKEN = import.meta.env.VITE_MIXPANEL_TOKEN ?? ''
export const MIXPANEL_DEBUG = import.meta.env.VITE_MIXPANEL_DEBUG === 'true'

/** GlobalStyles #root max-width 와 fixed 오버레이(WinnerToast 등) 폭 계산의 단일 기준 */
export const APP_MAX_WIDTH_PX = 480

/** WinnerToast 스크롤 dismiss 충돌 기준 요소(EnergyBadge) 조회용 id */
export const ENERGY_BADGE_ID = 'energy-badge'

export const DRAW_ANIMATION_MIN_DURATION_MS = 2500
export const BRIDGE_READY_TIMEOUT_MS = 5000
export const API_TIMEOUT_MS = 5000

export const NETWORK_ERROR_DESCRIPTION = '네트워크 상태가 불안정해요\n다시 시도해 주세요'
